

import ToastEventBus from 'primevue/toasteventbus';
import ConfirmationEventBus from 'primevue/confirmationeventbus';
export function useToastConfirm(i18n) {
  const { t } = i18n.global;
 
  const showToast = (msg, options) => {
    let type = options?.type || 'success';
    if(type=="warning"){
      type="warn"
    }
    let title;
    let message = {
        'success': t('global.success'),
        'error': t('global.fail'),
        'warn': t('global.warn'),
    };

    try {
        title = message[type] || t('global.alert');
    } catch (_) {
        title = t('global.alert');
    }

    // Nếu msg là một mảng, nối các phần tử thành chuỗi, mỗi phần tử trên một dòng
    const detail = Array.isArray(msg) ? msg.join('\n') : msg;

    ToastEventBus.emit('add', {
        severity: options?.type || 'success',
        summary: options?.title || title,
        detail: detail,
        life: 3000,
    });
  };


 
  const showConfirm = (data) => {
    ConfirmationEventBus.emit('confirm',{
      message: data.content,
      header: data.title,
      icon: 'pi pi-exclamation-triangle',
      rejectClass: data.rejectClass || 'p-button-secondary p-button-outlined',
      acceptClass: data.acceptClass || '',
      //rejectLabel: data.cancel || t('confirm.cancel'),
      //acceptLabel: data.ok || t('confirm.ok'),
      rejectLabel: data.cancel || t('global.cancel'),
      acceptLabel: data.ok || t('global.ok'),
      accept: () => {
        if (typeof data.accept === 'function') {
          data.accept();
        }
      },
      reject: () => {
        if (typeof data.reject === 'function') {
          data.reject();
        }
      }
    });
  };
  // const showConfirmPopup = (data) => {
  //   console.log('showConfirmPopup',data);
  //   ConfirmationEventBus.emit('confirm',{
  //     target: data.event.currentTarget,
  //     group: data.group,
  //     message: data.content,
  //     header: data.title,
  //     accept: () => {
  //       if (typeof data.accept === 'function') {
  //         data.accept();
  //       }
  //     },
  //     reject: () => {
  //       if (typeof data.reject === 'function') {
  //         data.reject();
  //       }
  //     }
  //   });
  // };
  return {
    showToast,
    showConfirm,
    // showConfirmPopup
  };
}
